import {
    onBeforeMount,
    reactive,
    ref,
    getCurrentInstance,
} from "@vue/composition-api";
import useValidationModal from "@/@core/components/base-modal/hooks/useValidationModal";
import quizListModel from "@/models/survey-quiz/quiz-list";
import router from "@/router";
import store from "@/store"
import useModal from "@/@core/components/base-modal/hooks/useModal";

export default function useChangePermission(props) {
    const vm = getCurrentInstance().proxy;
    const { fetchQuizDetailModel, } = quizListModel();
    const { openErrorModal, openDefaultErrorModal } = useValidationModal();
    const { openModal, closeModal } = useModal();


    const loading = ref(false);

    const TAG_ADD = ref(1);
    const permissionForm = reactive({
        quizGroupId: null,

        visibility: [],
        quizzer: [],
        duplicate: "",
        numberPlayers: 1,
        usageLimit: 0,
        numberUses: [],
        selectedTag: TAG_ADD,
        headerName: "กรุณาตั้งค่าสิทธิ์การเข้าใช้งานเกม",
    });

    if (router.currentRoute.query.quizGroupId) {
        permissionForm.quizGroupId = parseInt(router.currentRoute.query.quizGroupId)

    } else {
        permissionForm.quizGroupId = parseInt(router.currentRoute.params.ref)
    }

    const selectedTagPer = (tag) => {
        props.tagOption.quizzerOption = tag;
        if (props.tagOption.quizzerOption.length != permissionForm.quizzer.length) {
            let filterQuizze = props.tagOption.quizzerOption.filter((e) => {
                return permissionForm.quizzer.indexOf(e) > -1;
            });
            permissionForm.quizzer = filterQuizze
        }
    };

    const checkDuplicateTag = (tag) => {
        if (tag) {
            permissionForm.quizzer = props.tagOption.quizzerOption;
        } else {
            permissionForm.quizzer = "";
        }
    };

    const fetchQuizDetail = () => {
        window.$loading(true);
        fetchQuizDetailModel.payload.GroupId = permissionForm.quizGroupId;
        store
            .dispatch("api/apiFormRequest", fetchQuizDetailModel)
            .then((response) => {
                const respQuizGroup = response.data.resp.quiz_group;
                const respQuizTagQuizzer = response.data.resp.tag_quizzer_name;
                const respQuizTagVisibility = response.data.resp.tag_visibility_name;

                permissionForm.quizGroupId = respQuizGroup.quiz_groupid;
                TAG_ADD.value = respQuizGroup.permission_type;
                permissionForm.numberPlayers = respQuizGroup.islimit
                permissionForm.usageLimit = respQuizGroup.limit
                permissionForm.visibility = respQuizTagVisibility;
                permissionForm.quizzer = respQuizTagQuizzer;

                props.tagOption.quizzerOption = permissionForm.visibility


            })
            .catch((err) => {
                openDefaultErrorModal(err);
            })
            .finally(() => {
                window.$loading(false);
            });
    };

    const onSubmitModal = () => {
        vm.$emit("onSubmitForm", permissionForm, TAG_ADD);
    }

    onBeforeMount(() => {
        fetchQuizDetail();
    });

    return {
        permissionForm,
        loading,
        TAG_ADD,
        onSubmitModal,
        selectedTagPer,
        checkDuplicateTag,
    };
}